module.exports = __webpack_public_path__ + "img/gear.73ded385.svg";